import { render, staticRenderFns } from "./menuNum.vue?vue&type=template&id=01f59b8d&scoped=true"
import script from "./menuNum.vue?vue&type=script&lang=js"
export * from "./menuNum.vue?vue&type=script&lang=js"
import style0 from "./menuNum.vue?vue&type=style&index=0&id=01f59b8d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f59b8d",
  null
  
)

export default component.exports